// native
import { NgModule } from "@angular/core";

// module
import { SharedModule } from "../shared/shared.module";

// component
import { ExportTasksComponent } from "./export-tasks.component";
import { ExportTaskFormComponent } from "./export-task-form.component";

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    ExportTasksComponent,
    ExportTaskFormComponent
  ]
})
export class ExportTasksModule { }